import React from "react";

import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "material-ui/Dialog";

import { withStyles } from "material-ui/styles";

const styles = {
  contentText: {
    whiteSpace: "pre-line"
  }
};

class MessageDialog extends React.Component {
  defaultAction() {
    return <Button onClick={this.props.handleClose}>閉じる</Button>;
  }

  render() {
    const { open, message } = this.props.messageDialog;
    if (!message || !message.length) {
      return null;
    }
    return (
      <Dialog
        disableBackdropClick={process.env.NODE_ENV === "production"}
        open={open}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">確認</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={this.props.classes.contentText}
          >
            {Array.isArray(message) ? message.map(m => <span key={m}>{m}<br /></span>) : message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{this.defaultAction()}</DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(MessageDialog);



// WEBPACK FOOTER //
// ./src/components/MessageDialog.jsx